module.exports = ".page-item.dot-blank {\n  padding: 10px 15px;\n}"